/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Assistant_BusyInputs */

const en_error_assistant_busy = /** @type {(inputs: Error_Assistant_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The assistant is writing another answer for you. Ask again when it is done.`)
};

/**
* | output |
* | --- |
* | "The assistant is writing another answer for you. Ask again when it is done." |
*
* @param {Error_Assistant_BusyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_assistant_busy = /** @type {((inputs?: Error_Assistant_BusyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Assistant_BusyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_assistant_busy(inputs)
});